import React, { useState, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FiMail } from "react-icons/fi";
import './ForgotPassword.css';
import {BASE_URL} from "../../Constants";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [emailFocused, setEmailFocused] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const buttonRef = useRef(null);

    // Handle ripple effect on button click
    const createRipple = (event) => {
        const button = event.currentTarget;
        const circle = document.createElement("span");
        const diameter = Math.max(button.clientWidth, button.clientHeight);
        const radius = diameter / 2;

        // Position the ripple exactly where clicked
        const rect = button.getBoundingClientRect();
        circle.style.width = circle.style.height = `${diameter}px`;
        circle.style.left = `${event.clientX - rect.left - radius}px`;
        circle.style.top = `${event.clientY - rect.top - radius}px`;
        circle.classList.add("ripple");

        // Remove existing ripples
        const ripple = button.getElementsByClassName("ripple")[0];
        if (ripple) {
            ripple.remove();
        }

        button.appendChild(circle);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            setMessage("Te rugăm să introduci adresa de email.");
            setIsSuccess(false);
            return;
        }

        try {
            setIsLoading(true);
            setMessage("");

            const response = await axios.post(`${BASE_URL}/user/forgot-password`, {
                email
            });

            setIsSuccess(true);
            setMessage(response.data.message || "Un email de resetare a parolei a fost trimis la adresa ta de email.");
            setEmail("");
        } catch (error) {
            setIsSuccess(false);
            setMessage(
                error.response?.data?.message ||
                "A apărut o eroare. Te rugăm să încerci din nou."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-image">
                <div className="forgot-password-image-overlay">
                    <h1>Resetare parolă</h1>
                    <p>Introduceți adresa dvs. de email și vă vom trimite un link pentru resetarea parolei.</p>
                </div>
            </div>
            <div className="forgot-password-box">
                <div className="forgot-password-header">
                    <h2>Ați uitat parola?</h2>
                    <p>Introduceți adresa dvs. de email și vă vom trimite instrucțiuni pentru resetarea parolei.</p>
                </div>
                {isSuccess ? (
                    <div className="success-message">
                        <div className="success-icon">✓</div>
                        <p>{message}</p>
                        <Link to="/login" className="back-to-login">Înapoi la pagina de autentificare</Link>
                    </div>
                ) : (
                    <form className="forgot-password-form" onSubmit={handleSubmit}>
                        <div className={`input-container ${emailFocused ? 'focus' : ''}`}>
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Introduceți adresa de email"
                                onFocus={() => setEmailFocused(true)}
                                onBlur={() => setEmailFocused(false)}
                                required
                            />
                            <FiMail className="input-icon" />
                        </div>
                        <button
                            type="submit"
                            className={`reset-btn ${isLoading ? 'loading' : ''}`}
                            onClick={createRipple}
                            ref={buttonRef}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="spinner"></span>
                                    <span className="btn-text">Se procesează...</span>
                                </>
                            ) : (
                                <span className="btn-text">Trimite link de resetare</span>
                            )}
                        </button>
                        {message && !isSuccess && <p className="error-message">{message}</p>}
                        <div className="back-link">
                            <Link to="/login">Înapoi la pagina de autentificare</Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;